import axios from 'axios';
import {getLang, getWstaticUrl, getWstaticUrlObjectStorage} from './common/Utils';

export async function getI18NMessage(){
	let lang = getLang();
	let result;
	let wstaticUrl = getWstaticUrlObjectStorage();

	//lang 값이 없을 경우
	if(lang === "" || lang === null || lang === undefined || ( lang != null && typeof lang === "object" && !Object.keys(lang).length)){
		document.documentElement.setAttribute('lang', 'en');
		lang = 'en';
	}

	try{
		result = await axios({
			method: 'get',
			responseType: 'json',
			url: `${wstaticUrl}/i18n/common-banner/${lang}.json`
		}).then(function(response){
			return response.data;
		});

		return result;
		
	}catch(err){
		console.error(`Get Json: ${lang} fail`);
		throw(err);
	}
}

